import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState, InputObservable, trackByIndex } from '@y42/angular/util';
import { DataTestRunnerState, TestResultStatus } from '@y42/data-test';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataTestResultToIcon } from '../../state';

export type DataTestErrorDisplayInputParameter = Pick<DataTestRunnerState['runTest'], 'response' | 'httpErrorOccurred'>;

@UntilDestroy()
@Component({
  selector: 'y42-data-test-run-error-display',
  templateUrl: './data-test-run-error-display.component.html',
  styleUrls: ['./data-test-run-error-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestRunErrorDisplayComponent {
  @Input()
  @InputObservable()
  dataTestRunResult!: DataTestErrorDisplayInputParameter;
  dataTestRunResult$!: Observable<DataTestErrorDisplayInputParameter | null | undefined>;

  readonly state = connectState(this, {
    showError: this.dataTestRunResult$.pipe(
      map(
        (result) =>
          (result?.response?.status === TestResultStatus.Error ?? false) || (result?.httpErrorOccurred ?? false),
      ),
    ),
    showSuccess: this.dataTestRunResult$.pipe(map((result) => result?.response?.status === TestResultStatus.Success)),
    failedRowsCount: this.dataTestRunResult$.pipe(map((result) => result?.response?.num_rows_failed ?? null)),
  });

  readonly errorLabelAndIcon = DataTestResultToIcon[TestResultStatus.Error];
  readonly successLabelAndIcon = DataTestResultToIcon[TestResultStatus.Success];
  readonly trackBy = trackByIndex;
}
